import { Conditions, Features, Images } from '../../typings'

export interface IPayoutDuration {
  duration: keyof typeof PAYOUT_DURATION_MAP
}

export interface IFeatures {
  features: Features
}

export interface IConditions {
  conditions: Conditions
}

export interface IAddress {
  address: string
  logos: Images
}

export enum PAYOUT_DURATION_MAP {
  'same_day' = '0',
  '1_2_days' = '1-2',
  '2_3_days' = '2-3',
  '3_4_days' = '3-4',
  '4_5_days' = '4-5',
  '1_week' = '7',
  '5_10_days' = '5-10',
  'more_than_10_days' = '10+',
  'unknown' = 'unknown',
}

export enum UNSCHEDULED_REPAYMENT_MAP {
  'unknown',
  'free_of_charge',
  'chargeable',
}

export enum INSTALLMENT_BREAK_MAP {
  'unknown',
  'no_installment_break',
  'free_of_charge',
  'chargeable',
  'free_of_charge_after_individual_check',
  'chargeable_and_after_individual_check',
}
